import { render } from "./FriendsNpc2.vue?vue&type=template&id=b4ffc64e&scoped=true"
import script from "./FriendsNpc2.vue?vue&type=script&lang=js"
export * from "./FriendsNpc2.vue?vue&type=script&lang=js"

import "./FriendsNpc2.vue?vue&type=style&index=0&id=b4ffc64e&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ffc64e"]])

export default __exports__